import React from 'react';

export default ({ className }) => (
  <svg className={className}width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.556 8.416L6.752 6.736H6.716V12.376H5V4H6.992L9.284 7.96L10.088 9.64H10.124V4H11.84V12.376H9.848L7.556 8.416Z"/>
  </svg>
);
